// extracted by mini-css-extract-plugin
export default {"about-page":"AboutPage_about-page__TukTs","about-article":"AboutPage_about-article__+cE1U","about-paragraph":"AboutPage_about-paragraph__nLmC+"};